import { Injectable } from "@angular/core";
import { JQueryHTTPClient } from "../../../../rest/JQueryHTTPClient";
import { EntityService } from "../../../../rest/entity.service";
import { Rest } from "../../../../rest/rest_client";

@Injectable()
export class SyncProcessLogsService extends EntityService<Rest.InvSyncProcessLogs> {
    client: Rest.RestApplicationClient;

    constructor(private jquery: JQueryHTTPClient) {
        super();
        this.client = new Rest.RestApplicationClient(jquery);
    }


    getPage(
        arg0: Rest.ListPaginationRequest,
        queryParams?: { includeDisabled?: boolean }
    ): Rest.RestResponse<Rest.Page<Rest.InvSyncProcessLogs>> {
        try {
            return this.client.SyncProcessLogs_getPage(arg0, queryParams);
        } catch (error) {
            console.error("Error getting page:", error);
            throw error;
        }
    }

   
}